<div class="content">
    <h1>Terms and Conditions</h1>
    <em>Effective Date: 7/28/2025</em>

    <p>Welcome to the WondrVoices app, a program of <a href="https://wondrlink.org/" target="_blank">the Wondrlink Foundation, a 501(c)(3) nonprofit</a> organization. By
        accessing or using this app, you agree to the following Terms and Conditions:</p>

    <h2>1. Purpose</h2>
    <p>WondrVoices allows individuals to submit uplifting, creative, or supportive visual messages (such as handwritten
        notes, drawings, or cards) to be shared with individuals affected by cancer and serious illness. These contributions
        help foster empathy, community, and emotional support.</p>

    <h2>2. Submissions and Content Rights</h2>
    <p>When you submit content (e.g., images of cards, drawings, photos or artwork), you retain ownership of your
        submission.</p>
    <p>However, by submitting, you grant Wondrlink Foundation a non-exclusive, royalty-free, worldwide, irrevocable license
        to use, reproduce, print, modify, adapt, publish, distribute, and publicly display the content to further its
        charitable mission.</p>
    <p>This includes, but is not limited to, printing and sharing your submissions with patients or in fundraising campaigns
        related to cancer support.</p>
    <p>We will never use your content for third-party advertising or unrelated commercial purposes.</p>

    <h2>3. Attribution and Credit</h2>
    <p>You may optionally provide your name and email and also name someone to be credited for the submission.</p>
    <p>As of now, we do not display this information publicly.</p>
    <p>In the future, if public credit is implemented, we will only show attribution if you explicitly authorize us to do
        so.</p>

    <h2>4. Location Data</h2>
    <p>We may request your approximate location at the time of upload, only to understand the geographic reach of our
        community.</p>
    <p>This data is never displayed publicly, nor is it used for advertising or tracking individual users.</p>

    <h2>5. Moderation and Public Display</h2>
    <p>All submissions are manually reviewed by our team before being published or used.</p>
    <p>Not all submissions will be approved.</p>
    <p>Reasons for non-approval may include: inappropriate or offensive content, poor lighting, blurry or low-resolution
        images, or messages that are off-topic, insensitive, or do not align with the mission of emotional support.</p>
    <p>Currently, only selected and approved submissions are shown on our website. Some of these may also be printed and
        sent to patients as physical cards.</p>
    <p>This review process ensures that what is shared reflects our standards of care, kindness, and clarity.</p>

    <h2>6. Removal and Deletion Requests</h2>
    <p>You may request to view or delete your submission by contacting us at contact&#64;wondrlink.org.</p>
    <p>If your content has already been printed or distributed, we cannot retrieve or undo past uses.</p>
    <p>As submissions are not tied to user accounts, we may require sufficient proof of ownership before deletion.</p>

    <h2>7. Donations and Fundraising</h2>
    <p>The app may include a link to make voluntary donations to support the mission of Wondrlink Foundation.</p>
    <p>All donations are processed through a secure third-party provider and are governed by their privacy and security
        policies.</p>

    <h2>8. Contact Us</h2>
    <p>If you have questions about these terms, contact us at contact&#64;wondrlink.org.</p>
</div>